<template>
  <Modal
    :modal-title="modalTitle"
    :prev-button="!isCheckout"
    :close-button="isCheckout"
    @prev="goPrev"
    @next="goNext"
    @close="close"
  >
    <div v-if="isLoading" class="loading-overlay">
      <loader />
    </div>

    <MyCart
      v-if="!isCheckout"
      :data="purchasingData"
      :payment-intent="paymentIntent"
      :update-email="updateEmail"
      @close-update-email="closeUpdateEmail"
      @update="updateCartData"
      @pay="onCartCheckout"
      @goPrev="goPrev"
      @goNext="goNext"
    />

    <Congrats
      v-else
      :data="purchasingData"
      :payment-intent="paymentIntent"
      :update-email="updateEmail"
      @close-update-email="closeUpdateEmail"
      @update="updateCartData"
      @pay="onCartCheckout"
      @goPrev="goPrev"
      @goNext="goNext"
    />

    <rounded-card
      v-if="showPrompt"
      show-right-btn
      class="p-3 z-40"
      @set-close-status="togglePrompt"
    >
      <div class="px-6 p-y pt-0 text-center flex flex-1 flex-col items-center">
        <!-- No Credits -->
        <template>
          <h3 class="text-xl whitespace-pre">
            {{ $t('mobileScan.no_email') }}
          </h3>
          <img
            class="my-auto"
            width="170"
            src="../../../assets/Discovery/no_email.svg"
            :alt="$t('mobileScan.no_email')"
          />
          <c-button class="my-auto" @click="goToUpdateEmail">
            <span>{{ $t('mobileScan.update_email') }}</span>
          </c-button>
        </template>
      </div>
    </rounded-card>
  </Modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ApiActions from '@/modules/api-actions';
import { EVENTS as HW_EVENTS } from '@/events/hardware';
import page from '@/mixins/page';
import RoundedCard from '@/components/common/RoundedCard.vue';
import Modal from '@/components/common/Modal.vue';
import MyCart from '@/components/MobileScan/Purchase/MyCart.vue';
import Congrats from '@/components/MobileScan/Purchase/Congrats.vue';
import Loader from '@/components/common/Loader.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'Purchase',
  mixins: [page],
  components: {
    MyCart,
    Modal,
    Congrats,
    Loader,
    RoundedCard,
    CButton,
  },
  data: () => ({
    purchasingData: {},
    paymentIntent: {},
    isCheckout: false,
    isLoading: false,
    showPrompt: false,
    updateEmail: false,
  }),
  computed: {
    ...mapState('user', ['auth', 'me']),
    ...mapGetters('app', ['storeId']),
    modalTitle() {
      let title = '';
      if (!this.isCheckout) {
        title = this.$t('mobileScan.purchase_cart');
        if (this.updateEmail) {
          title = this.$t('mobileScan.update_email');
        }
      }
      return title;
    },
    modalContent() {
      return !this.isCheckout ? 'my-cart' : 'congrats';
    },
  },
  mounted() {
    this.$events.on(HW_EVENTS.MOBILE_PAYMENT_CANCELED, this.onPaymentCanceled);
    this.$events.on(HW_EVENTS.MOBILE_PAYMENT_SUCCEED, this.onPaymentSucceed);
  },
  beforeDestroy() {
    this.$events.off(HW_EVENTS.MOBILE_PAYMENT_CANCELED, this.onPaymentCanceled);
    this.$events.off(HW_EVENTS.MOBILE_PAYMENT_SUCCEED, this.onPaymentSucceed);
  },
  methods: {
    updateCartData(data) {
      this.purchasingData = { ...data };
    },
    togglePrompt() {
      this.showPrompt = !this.showPrompt;
    },
    goToUpdateEmail() {
      this.showPrompt = false;
      this.updateEmail = true;
    },
    closeUpdateEmail() {
      console.log('[closeUpdateEmail]');
      this.updateEmail = false;
    },
    reset() {
      this.isCheckout = false;
    },
    close() {
      this.reset();
      this.$emit('close');
    },
    goPrev() {
      if (this.updateEmail) {
        this.updateEmail = false;
        return;
      }

      if (this.isCheckout) {
        this.isCheckout = false;
        this.paymentIntent = {};
        return;
      }
      this.$emit('close');
    },
    goNext() {
      this.isCheckout = true;
    },
    async onCartCheckout() {
      if (!this.me.email) {
        this.togglePrompt();
        return;
      }

      this.isLoading = true;
      const input = {
        credits: this.purchasingData.totalCredits,
        store_id: this.storeId,
      };

      try {
        const { data } = await ApiActions.user.purchaseCredits(input);
        this.$events.emit(HW_EVENTS.MOBILE_REQUEST_PAYMENT, data);
        this.paymentIntent = data;
      } catch (e) {
        console.log(e.message);
        this.isLoading = false;
        this.$toasted.global.alert(this.$t('welcome.unexpected_error'));
      }
    },
    onPaymentCanceled() {
      this.isLoading = false;
    },
    onPaymentSucceed() {
      this.purchasingData = {};
      this.isLoading = false;
      this.goNext();
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  @apply absolute flex w-full h-full z-50 justify-center items-center;
  top: 0;
  left: 0;
  background-color: #fff;
  opacity: 0.85;
}
</style>
